import { render } from "./SolutionsBenefits.vue?vue&type=template&id=04b45164&lang=pug"
import script from "./SolutionsBenefits.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionsBenefits.vue?vue&type=script&setup=true&lang=js"

import "./SolutionsBenefits.vue?vue&type=style&index=0&id=04b45164&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__